import { render, staticRenderFns } from "./UserCompanyProfile.vue?vue&type=template&id=b0d33726"
import script from "./UserCompanyProfile.vue?vue&type=script&lang=js"
export * from "./UserCompanyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports